import React from 'react';
import type {
  AppGroupSection,
  CategoryCarouselSection,
  Section,
} from '@wix/app-market-services';
import {
  useAppsSectionSharedPropsMapper,
  useCategoryCarouselSharedPropsMapper,
  useRouterContext,
  AppMarketPage,
  useEssentials,
  homePageId,
} from '@wix/app-market-core';
import { RoutePath } from '@wix/app-market-core-types';
import { AppsSection, CategoryCarousel } from '@wix/app-market-components';
import { monitoredHomePageSections } from './monitored-home-sections';

export function HomePageSection({
  section,
  index,
}: {
  section: Section;
  index: number;
}) {
  const page = AppMarketPage.HOMEPAGE;
  const { router } = useRouterContext();
  const { marketWatch } = useEssentials();
  const appsSectionSharedPropsMapper = useAppsSectionSharedPropsMapper();
  const categoryCarouselSharedPropsMapper =
    useCategoryCarouselSharedPropsMapper();

  if (section.appGroup) {
    if (monitoredHomePageSections.includes(section.appGroup.tagSlug!)) {
      const sectionsAppsCountMonitor = marketWatch
        .monitor(homePageId)
        .transaction(`${section.appGroup.tagSlug}-apps-count`);
      sectionsAppsCountMonitor.start();
      if (section.appGroup.apps!.length > 2) {
        sectionsAppsCountMonitor.finish();
      }
    }

    return (
      <AppsSection
        {...appsSectionSharedPropsMapper(
          section?.appGroup as AppGroupSection,
          page,
          page,
          index,
          undefined,
          'medium',
          {
            path: RoutePath.COLLECTION,
            payload: {
              slug: section?.appGroup?.tagSlug ?? '',
              referral: 'view_more_apps',
            },
          },
        )}
        onButtonClick={() => {
          router.navigateTo({
            path: RoutePath.COLLECTION,
            payload: {
              slug: section?.appGroup?.tagSlug ?? '',
            },
          });
        }}
      />
    );
  }
  if (section.categoryCarousel) {
    return (
      <CategoryCarousel
        {...categoryCarouselSharedPropsMapper(
          section.categoryCarousel as CategoryCarouselSection,
          page,
        )}
      />
    );
  }
  return null;
}
